export const styleFixes = {
  'a.MuiButtonBase-root': { outline: 'none', textDecoration: 'none' },
  'a.MuiButtonBase-root:hover': { color: 'inherit' },
  'a.MuiButtonBase-root:focus': { color: 'inherit' },
  'a.MuiButton-contained:hover': { color: '#fff' },
  'a.MuiButton-contained:focus': { color: '#fff' },
  'a.MuiLink-root:focus': { color: 'inherit', textDecoration: 'none' },
  'a.MuiLink-root:hover': { color: 'inherit', textDecoration: 'none' },
  '.main-container': { paddingTop: '20px', minHeight: '60vh' },
  '.node-type-cv-collection .main-container': { minHeight: 'initial' },
  '.page-travel-agent-private-label #page-title': { paddingBottom: '10px' },
  '.node-type-cv-story .main-container': { paddingTop: '0px' },
  '.node-type-page.front .main-container': { paddingTop: '0px' },
  '.page-travel-agent .main-container': { paddingBottom: '20px' },
  '.page-travel-agent.page-travel-agent-groups-overview .main-container': { paddingBottom: 0 },
  '.page-travel-agent.page-travel-agent-private-label .main-container': { paddingBottom: 0 },
  '.page-travel-agent-private-label hr': { borderTop: 0 },
};
